import { POSTWithAuthNoResponse } from './Index'

export async function Follow(address: string): Promise<void> {
  return await POSTWithAuthNoResponse<null>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${address}/follow`,
    null
  )
}

export async function Unfollow(address: string): Promise<void> {
  return await POSTWithAuthNoResponse<null>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${address}/unfollow`,
    null
  )
}
